export type BtnTaraticColor =
  | 'blue'
  | 'green'
  | 'orange'
  | 'red'
  | 'purple'
  | 'indigo'
  | 'black'
  | 'outline'
  | 'ghost-dark'
  | 'ghost'
  | 'pink';

export type BtnTaraticSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface BtnTaraticStyleOptions {
  color?: BtnTaraticColor;
  size?: BtnTaraticSize;
  iconOnly?: boolean;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

export function computeBtnTaraticClasses({
  color = 'ghost-dark',
  size = 'sm',
  iconOnly = false,
  className = '',
}: BtnTaraticStyleOptions = {}): string {
  const normalizedColor = color === 'ghost' ? 'ghost-dark' : color;
  const colorClass = normalizedColor ? `btn-${normalizedColor}` : '';
  const sizeClass = !iconOnly && size !== 'md' ? `btn-${size}` : '';
  const iconClass = iconOnly ? 'w-9 h-9 rounded-full flex items-center justify-center p-0' : '';

  return `btn-taratic ${colorClass} ${sizeClass} ${iconClass} ${className}`.trim();
}

export function isBtnTaraticColor(color: string): color is BtnTaraticColor {
  return [
    'blue',
    'green',
    'orange',
    'red',
    'purple',
    'indigo',
    'black',
    'outline',
    'ghost-dark',
    'ghost',
    'pink',
  ].includes(color);
}
